// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4884fe1","732":"fcd05cef","977":"8da90ef0"}[chunkId] + ".chunk.js";
};